import { useCallback } from 'react';
import { ApiButton } from 'web-library';
import { usePutJobStatusReportResetRetry } from '../../../../api-refactored/job-status-report/usePutJobStatusReportResetRetry';

interface JobStatusReportResetRetryProps {
  label: string;
  uuids: string[];
}

const JobStatusReportResetRetry = ({ label, uuids }: JobStatusReportResetRetryProps) => {
  const { mutate: resetRetries, status: ApiButtonStatus } = usePutJobStatusReportResetRetry({});

  const onClick = useCallback(() => {
    resetRetries(uuids);
  }, [resetRetries, uuids]);

  return (
    <ApiButton
      color="primary"
      variant="text"
      status={ApiButtonStatus}
      size="small"
      onClick={onClick}
    >
      {label}
    </ApiButton>
  );
};

export default JobStatusReportResetRetry;
